import module from 'fan/proyecto/module.js'

export class FanProyectoDocumentosPlantillaPdfService {
  constructor($api, $http, $timeout, $q) {
    this.$api = $api
    this.$http = $http
    this.$timeout = $timeout
    this.$q = $q
  }

  post(idProyecto, idPlantilla, version, config, params) {
    return this.$http.put('/api2/proyecto/documentos/plantilla/pdf', config, {
      params: {
        id_proyecto: idProyecto,
        id_plantilla: idPlantilla,
        version: version,
        params: params
      },
      download: true,
    })
  }

  link(idProyecto, idPlantilla, version) {
    return this.$api.link('/api2/proyecto/documentos/plantilla/pdf', {
      id_proyecto: idProyecto,
      id_plantilla: idPlantilla,
      version: version,
    })
  }
}

module.service('FanProyectoDocumentosPlantillaPdfService', FanProyectoDocumentosPlantillaPdfService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Documentos/Plantilla/Pdf.js